module.exports = __webpack_public_path__ + "media/src/images/abouts/items/online/original-beead5c1fbadb0740534c38796c6a4c1.jpg";